// @flow
import * as React from 'react';
import ShowMap from './ShowMap'
import SortBy from './SortBy'
import Filters from './Filters'
import Share from './Share';
import { Bar, BarWrapper, Group, HideMobile, ResponsiveFiltersButton } from './elements';

export default function FilterMenu () {
  return (
    <BarWrapper>
      <Bar>
        <Group $left>
          <HideMobile>
            <SortBy />
          </HideMobile>

          <ResponsiveFiltersButton>
            <Filters />
          </ResponsiveFiltersButton>
        </Group>

        <Group $right>
          <Share />

          <HideMobile>
            <ShowMap />
          </HideMobile>
        </Group>
      </Bar>
    </BarWrapper>
  )
}
